<template>
    <div class="container-fluid reservas-view">
        <headerApp :title="title"></headerApp>
        <div v-if="!settings.modulo_reserva_de_viajes" class="reservas-empty">
            <p>{{ translate('moduloNoDisponible') }}</p>
        </div>
        <template v-else>
            <div v-if="loading" class="reservas-loading">
                <svg-item :icon="'loading'" :color="'--text-color'" size="48" class="spin" />
                <div>{{ translate('cargando') }}</div>
            </div>
            <div v-else-if="list.length === 0" class="reservas-empty">
                <p>{{ isDriver ? translate('sinReservasAceptadas') : translate('misReservasVacio') }}</p>
            </div>
            <div v-else class="reservas-list">
                <div v-for="item in list" :key="item.id" class="reserva-card history-item">
                    <div class="row" v-if="!isDriver && item.chofer && item.chofer.usuario">
                        <div class="col-xs-24">
                            <div class="trip-card--left">
                                <img v-imgSrc="profilePic(item)" class="driver-profile-photo" />
                            </div>
                            <div class="driver-description">
                                <div v-lang.chofer>Chofer</div>
                                <div class="text-strong">{{ item.chofer.usuario.nombre }} {{ item.chofer.usuario.apellido }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="isDriver && item.pasajero">
                        <div class="col-xs-24">
                            <div class="driver-description">
                                <div v-lang.pasajerx>Pasajero/a</div>
                                <div class="text-strong">{{ item.pasajero.nombre }} {{ item.pasajero.apellido }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <svg-item size="24" :icon="'calendar'" :color="'--text-color'"></svg-item>
                            {{ formatDate(item.fecha_hora_reserva) }}
                        </div>
                        <div class="col-xs-12">
                            <svg-item size="24" :icon="'time'" :color="'--text-color'"></svg-item>
                            {{ formatTime(item.fecha_hora_reserva) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-24">
                            <svg-item size="24" :icon="'gps'" :color="'--text-color'"></svg-item>
                            {{ item.calle }} {{ item.altura >= 0 ? item.altura : '' }}
                        </div>
                    </div>
                    <div class="row" v-if="item.dest_nombre">
                        <div class="col-xs-24">
                            <svg-item size="24" :icon="'lugar'" :color="'--text-color'"></svg-item>
                            {{ item.dest_nombre }}
                        </div>
                    </div>
                    <div class="row" v-if="item.precio">
                        <div class="col-xs-24">
                            <svg-item size="24" :icon="'money-fill'" color="green"></svg-item>
                            {{ parseFloat(item.precio).toFixed(2) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-24 reserva-estado">
                            <span class="badge badge--pendiente" v-if="item.pago_reserva && item.pago_reserva.status === 'awaiting_driver'">{{ translate('estadoPendiente') }}</span>
                            <span class="badge badge--aceptado" v-else-if="item.pago_reserva && item.pago_reserva.status === 'awaiting_payment'">Chofer asignado - pendiente de pago</span>
                            <span class="badge badge--abordado" v-else-if="item.pago_reserva && item.pago_reserva.status === 'approved'">Confirmada</span>
                            <span class="badge badge--finalizado" v-else-if="item.pago_reserva && item.pago_reserva.status === 'cancelled' && item.pago_reserva.cancel_reason === 'payment_timeout'">Cancelada por falta de pago</span>

                            <span class="badge badge--pendiente" v-else-if="item.estado === 0">{{ translate('estadoPendiente') }}</span>
                            <span class="badge badge--aceptado" v-else-if="item.estado === 1">{{ translate('estadoAceptado') }}</span>
                            <span class="badge badge--abordado" v-else-if="item.estado === 2">{{ translate('estadoAbordado') }}</span>
                            <span class="badge badge--finalizado" v-else-if="item.estado === 4">{{ translate('estadoFinalizado') }}</span>
                        </div>
                    </div>
                    <div class="row" v-if="showReservaResidenteDevolucionAviso(item)">
                        <div class="col-xs-24 reserva-resident-refund-hint">
                            {{ translate('reservaResidenteDevolucionAviso', { pct: reservaResidentRefundPctLabel() }) }}
                        </div>
                    </div>
                    <div class="row" v-if="showReservaWhatsappHelp(item)">
                        <div class="col-xs-24">
                            <a
                                class="btn btn-success btn-whatsapp-help"
                                :href="whatsappHelpHref"
                                target="_blank"
                                rel="noopener noreferrer">
                                Contactar ayuda por WhatsApp
                            </a>
                        </div>
                    </div>
                    <div class="row" v-if="!isDriver && item.pago_reserva && item.pago_reserva.status === 'awaiting_payment'">
                        <div class="col-xs-24">
                            <div class="text-alert" v-if="formatDue(item.pago_reserva.payment_due_at)">{{ formatDue(item.pago_reserva.payment_due_at) }}</div>
                            <button
                                class="btn btn-primary"
                                :disabled="isDueExpired(item.pago_reserva.payment_due_at) || payLoadingId === item.pago_reserva.id"
                                @click="pagarReserva(item)">
                                {{ payLoadingId === item.pago_reserva.id ? 'Procesando...' : 'Pagar reserva' }}
                            </button>
                        </div>
                    </div>
                    <div class="row" v-if="!isDriver && canCancelItem(item)">
                        <div class="col-xs-24">
                            <button
                                class="btn btn-secondary btn-cancel-reserva"
                                :disabled="cancelLoadingId === item.id"
                                @click="onCancelReservation(item)">
                                {{ cancelLoadingId === item.id ? 'Procesando...' : translate('cancelarReserva') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { apis } from '@/services/api';
import dialogs from '@/services/dialogs';
import defaultProfilePic from '@/assets/img/default.jpg';
import { LangManager } from '@/services/language';
import { canCancelReservation } from '@/services/reservation';

export default {
    name: 'Reservas',
    data () {
        return {
            list: [],
            loading: true,
            nowTs: Date.now(),
            payLoadingId: null,
            cancelLoadingId: null,
            reservationsPollingMs: 30000
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            settings: 'company/config',
            isDriver: 'auth/isChofer',
            position: 'geolocation/actual'
        }),
        title () {
            return this.isDriver ? this.translate('reservasAceptadas') : this.translate('misReservas');
        },
        whatsappHelpPhoneRaw () {
            return this.settings && this.settings.reserva_whatsapp_ayuda_numero
                ? ('' + this.settings.reserva_whatsapp_ayuda_numero).trim()
                : '';
        },
        whatsappHelpPhoneDigits () {
            return this.whatsappHelpPhoneRaw.replace(/\D/g, '');
        },
        whatsappHelpHref () {
            if (!this.whatsappHelpPhoneDigits) return '';
            return `https://wa.me/${this.whatsappHelpPhoneDigits}`;
        }
    },
    mounted () {
        this.language = this.$getLang();
        if (this.settings.modulo_reserva_de_viajes) {
            this.fetchReservas(true);
            this._reservasPollingTimer = setInterval(() => {
                this.fetchReservas(false);
            }, this.reservationsPollingMs);
        } else {
            this.loading = false;
        }

        // Countdown for payment window (awaiting_payment).
        this._countdownTimer = setInterval(() => {
            this.nowTs = Date.now();
        }, 1000);
    },
    beforeDestroy () {
        if (this._countdownTimer) {
            clearInterval(this._countdownTimer);
            this._countdownTimer = null;
        }
        if (this._reservasPollingTimer) {
            clearInterval(this._reservasPollingTimer);
            this._reservasPollingTimer = null;
        }
    },
    methods: {
        ...mapActions({
            crearPreferenciaReserva: 'passenger/crearPreferenciaReserva',
            cancelReservation: 'passenger/cancelReservation'
        }),
        canCancelItem (item) {
            return canCancelReservation(item);
        },
        reservaResidentRefundPctLabel () {
            const configuredPct = this.settings ? parseFloat(this.settings.descuento_residente_jubilado) : 0;
            if (configuredPct > 0) {
                return this.settings.descuento_residente_jubilado;
            }
            return 25;
        },
        isReservationItem (item) {
            return !!item && (
                item.es_con_reserva === true ||
                item.es_con_reserva === 1 ||
                item.es_con_reserva === '1' ||
                !!item.fecha_hora_reserva
            );
        },
        pendingResidentBenefitForItem (item) {
            const pasajero = item && item.pasajero ? item.pasajero : this.user;
            if (!pasajero || pasajero.tipo_beneficio !== 'residente') return false;
            const approved = pasajero.beneficio_descuento_aprobado === true ||
                pasajero.beneficio_descuento_aprobado === 1 ||
                pasajero.beneficio_descuento_aprobado === '1';
            const rejected = pasajero.beneficio_descuento_rechazado === true ||
                pasajero.beneficio_estado === 'rechazado' ||
                pasajero.estado_beneficio_descuento === 'rechazado';
            return !approved && !rejected;
        },
        showReservaResidenteDevolucionAviso (item) {
            return !this.isDriver &&
                this.settings &&
                this.settings.modulo_descuento_residente_jubilado &&
                this.isReservationItem(item) &&
                this.pendingResidentBenefitForItem(item);
        },
        fetchReservas (showLoader = false) {
            if (!this.settings.modulo_reserva_de_viajes) {
                this.loading = false;
                return Promise.resolve();
            }
            if (showLoader) {
                this.loading = true;
            }
            const api = this.isDriver ? apis.choferesApi : apis.pasajerosApi;
            return api.reservas().then((res) => {
                const data = (res && res.data !== undefined) ? res.data : res;
                this.list = Array.isArray(data) ? data : [];
            }).catch(() => {
                if (showLoader) {
                    this.list = [];
                }
            }).finally(() => {
                if (showLoader) {
                    this.loading = false;
                }
            });
        },
        translate (key) {
            const translated = this.$lang ? this.$lang(key) : null;
            if (translated !== undefined && translated !== null && translated !== '') {
                return translated;
            }
            const fallback = LangManager.translate(key);
            return fallback !== undefined && fallback !== null && fallback !== '' ? fallback : key;
        },
        isDueExpired (paymentDueAt) {
            if (!paymentDueAt) return true;
            const d = new Date(paymentDueAt);
            if (isNaN(d.getTime())) return true;
            return d.getTime() <= this.nowTs;
        },
        formatDue (paymentDueAt) {
            if (!paymentDueAt) return null;
            const d = new Date(paymentDueAt);
            if (isNaN(d.getTime())) return null;
            const diffMs = d.getTime() - this.nowTs;
            if (diffMs <= 0) return 'Vencida';
            const totalSeconds = Math.floor(diffMs / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            if (hours > 0) return `Vence en ${hours}h ${minutes}m`;
            return `Vence en ${minutes}m`;
        },
        showReservaWhatsappHelp (item) {
            if (this.isDriver) return false;
            if (!this.whatsappHelpPhoneDigits) return false;
            if (!item || !item.fecha_hora_reserva) return false;
            if (!item.pago_reserva || item.pago_reserva.status !== 'approved') return false;

            const startAt = new Date(item.fecha_hora_reserva);
            if (isNaN(startAt.getTime())) return false;

            const minsBefore = parseInt(this.settings.reserva_minutos_antes_para_offer, 10);
            const activateBeforeMinutes = isNaN(minsBefore) ? 5 : minsBefore;
            const activationAt = startAt.getTime() - (activateBeforeMinutes * 60 * 1000);
            return Date.now() < activationAt;
        },
        pagarReserva (item) {
            if (!item || !item.pago_reserva) return;
            if (this.isDueExpired(item.pago_reserva.payment_due_at)) return;

            this.payLoadingId = item.pago_reserva.id;
            this.crearPreferenciaReserva({
                reserva_pago_id: item.pago_reserva.id,
                monto: item.pago_reserva.monto
            }).then((res) => {
                const body = (res && res.data !== undefined) ? res.data : res;
                if (body && body.init_point) {
                    window.location.href = body.init_point;
                } else {
                    dialogs.message(this.translate('problemaInesperado'), { duration: 10, estado: 'error' });
                }
            }).catch(() => {
                dialogs.message(this.translate('problemaInesperado'), { duration: 10, estado: 'error' });
            }).finally(() => {
                this.payLoadingId = null;
            });
        },
        formatDate (fechaHora) {
            if (!fechaHora) return '-';
            const d = new Date(fechaHora);
            return isNaN(d.getTime()) ? fechaHora : d.toLocaleDateString();
        },
        formatTime (fechaHora) {
            if (!fechaHora) return '-';
            const d = new Date(fechaHora);
            return isNaN(d.getTime()) ? '' : d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
        profilePic (item) {
            if (!item.chofer || !item.chofer.usuario) return defaultProfilePic;
            return item.chofer.usuario.photo ? this.$profile(item.chofer.usuario.photo) : defaultProfilePic;
        },
        onCancelReservation (item) {
            if (!item || !canCancelReservation(item) || this.cancelLoadingId) return;
            dialogs.confirm(
                this.translate('confirmarCancelacionReserva'),
                (index) => {
                    if (index !== 1) return;
                    this.cancelLoadingId = item.id;
                    this.cancelReservation({
                        reservation: item,
                        lat: this.position ? this.position.lat : 0,
                        lng: this.position ? this.position.lng : 0,
                        comentario: 'Cancelado por pasajero'
                    }).then(() => {
                        this.fetchReservas(false);
                    }).finally(() => {
                        this.cancelLoadingId = null;
                    });
                },
                this.translate('cancelarReserva'),
                [this.translate('si'), this.translate('no')]
            );
        }
    }
};
</script>

<style scoped>
.reservas-view { background: var(--form-background-color); min-height: 100%; }
.reservas-loading, .reservas-empty { text-align: center; padding: 2rem; }
.reservas-list { padding: 0.5rem; }
.reserva-card { margin-bottom: 1rem; padding: 1rem; background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.1); border-radius: 4px; }
.reserva-estado { margin-top: 0.5rem; }
.badge { display: inline-block; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.85em; }
.badge--pendiente { background: #fff3cd; color: #856404; }
.badge--aceptado { background: #cce5ff; color: #004085; }
.badge--abordado { background: #d4edda; color: #155724; }
.badge--finalizado { background: #e2e3e5; color: #383d41; }
.spin { animation: spin 1s linear infinite; display: inline-block; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
.driver-profile-photo { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
.trip-card--left { display: inline-block; vertical-align: middle; margin-right: 0.5rem; }
.driver-description { display: inline-block; vertical-align: middle; }
.row { margin-bottom: 0.35rem; }
.reserva-resident-refund-hint { color: red; font-size: 0.9em; font-weight: 500; line-height: 1.35; }
.btn-whatsapp-help { width: 100%; text-align: center; }
.btn-cancel-reserva { width: 100%; margin-top: 0.5rem; }
</style>



// WEBPACK FOOTER //
// src/components/views/Reservas.vue